module.exports = __webpack_public_path__ + "img/再接再厲.ac55afca.png";